import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'
import type {BioIconProps} from '../../icons/common-types'

export default function BestOnlineReviewsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          d="M13.3531 22.6007H8.2998C3.80647 22.6007 2.68647 21.4807 2.68647 16.9874V8.98736C2.68647 4.49402 3.80647 3.37402 8.2998 3.37402H22.3398C26.8331 3.37402 27.9531 4.49402 27.9531 8.98736"
          stroke="white"
          strokeWidth="1.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3531 28.6273V22.6006"
          stroke="white"
          strokeWidth="1.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M2.68647 17.2666H13.3531"
          stroke="white"
          strokeWidth="1.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00646 28.626H13.3531"
          stroke="white"
          strokeWidth="1.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.3532 17.0668V24.6801C29.3532 27.8401 28.5665 28.6268 25.4065 28.6268H20.6732C17.5132 28.6268 16.7265 27.8401 16.7265 24.6801V17.0668C16.7265 13.9068 17.5132 13.1201 20.6732 13.1201H25.4065C28.5665 13.1201 29.3532 13.9068 29.3532 17.0668Z"
          stroke="white"
          strokeWidth="1.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M23.0125 24.3337H23.0245"
          stroke="white"
          strokeWidth="2.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <span>Best Online Reviews</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
